import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match");
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password });
      setUser(data);
      toast.success("Password set — welcome aboard");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center max-w-sm">
          <h1 className="text-xl font-black">Invalid link</h1>
          <p className="text-sm text-muted-foreground mt-2">This invite link is missing its token. Please use the link from your invite email.</p>
          <Button className="mt-4 rounded-sm" onClick={() => navigate("/login")}>Go to login</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex items-center gap-2 mb-8">
          <img src="/nucleus-logo.png" alt="" className="h-10 w-10 object-contain" />
          <span className="font-bold text-lg tracking-tight">Neuclius</span>
        </div>
        <p className="overline-label">Activate account</p>
        <h2 className="text-2xl font-black tracking-tight mt-1 mb-6 flex items-center gap-2">
          <CheckCircle size={22} className="text-primary" weight="fill" /> Set your password
        </h2>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="overline-label" htmlFor="pw">New password</Label>
            <Input id="pw" type="password" required data-testid="set-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 rounded-sm" placeholder="••••••••" />
          </div>
          <div>
            <Label className="overline-label" htmlFor="cpw">Confirm password</Label>
            <Input id="cpw" type="password" required data-testid="confirm-password-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 rounded-sm" placeholder="••••••••" />
          </div>
          <Button type="submit" disabled={loading} data-testid="set-password-submit" className="w-full rounded-sm bg-primary hover:bg-primary/90 h-10 font-semibold group">
            {loading ? "Please wait…" : "Activate account"}
            <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-0.5" />
          </Button>
        </form>
      </div>
    </div>
  );
}
